import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a541ca9e")

_pushScopeId("data-v-a541ca9e")
const _hoisted_1 = { class: "search-container" }
const _hoisted_2 = { class: "search-form-item" }
const _hoisted_3 = { class: "form-label" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "el-icon-search" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { style: {"padding":"8px 8px"} }, " This advanced function is currently available for free ", -1)
const _hoisted_7 = { class: "img-hover-div" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_sec_date_picker = _resolveComponent("sec-date-picker")
  const _component_cus_button = _resolveComponent("cus-button")
  const _component_el_popover = _resolveComponent("el-popover")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$wordList.RecodeInHtmlDate) + ":", 1),
        _createVNode(_component_sec_date_picker, {
          modelValue: _ctx.formData.startTime,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.startTime = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_4,
        _createVNode(_component_sec_date_picker, {
          modelValue: _ctx.formData.endTime,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.endTime = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_cus_button, {
        onClick: _ctx.updateToList,
        class: "margin-right10px"
      }, {
        default: _withId(() => [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.$wordList.LogInHtmlSearch), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      (!_ctx.isRuServer())
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_cus_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emit('showExportDialog')))
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextExportLogs), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_popover, {
              ref: "exportTips",
              width: 250,
              trigger: "hover",
              placement: "top"
            }, {
              reference: _withId(() => [
                _createVNode("div", _hoisted_7, [
                  (!_ctx.isCNServer)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        class: "img-hover",
                        src: require('@/assets/image/Hover.png')
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }, 512)
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
})